import { Component, HostListener, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { ContextDossier } from '@kv-common-components/kv-common-components';
import {
    AuthenticationService,
    DocumentGed,
    EspaceClientService,
    EspaceDocumentaireService,
    SignatureService,
    User,
} from '@kv-common-components/kx-services';
import { RouterHelperService } from '@shared/services/router-helper.service';
import { AssuranceHelperService } from '@shared/services/assurance-helper.service';
import { RouteEnum } from '@shared/services/route-enum';
import { Subscription } from 'rxjs';
import { DeviceDetectorService } from 'ngx-device-detector';

@Component({
    templateUrl: './signature.component.html',
})
export class SignatureComponent implements OnInit {
    static readonly prefixTypologieProposition = 'PA ADE';

    idDossier: string;
    idPersonne: string;
    signatureUrl: SafeResourceUrl;
    contextDossier: ContextDossier;
    currentUser: User;
    goBackToEspaceClientModal = false;
    currentStepId: string;
    isPropositionSigned = false;
    isLoading = false;
    iframeError = false;
    iframeHeight = '1350px';
    espaceClientSubscription: Subscription;

    constructor(
        private sanitizer: DomSanitizer,
        private authenticationService: AuthenticationService,
        private signatureService: SignatureService,
        private router: Router,
        private routerHelper: RouterHelperService,
        private espaceClientService: EspaceClientService,
        private espaceDocumentaireService: EspaceDocumentaireService,
        private deviceDetectorService: DeviceDetectorService
    ) {
        this.goBackToEspaceClientModal = false;
        this.currentUser = this.authenticationService.currentUserValue;
        this.idDossier = this.currentUser.idDossier;
        this.idPersonne = this.currentUser.idPersonne;
        this.urlSignature();
    }

    @HostListener('window:message', ['$event'])
    onMessage(event) {
        if (event != null && event.data != null) {
            switch (event.data.status) {
                case 'ERROR':
                    this.iframeError = true;
                    break;
                case 'SUCCESS':
                    if (
                        AssuranceHelperService.isCodeAiaStatutDAForSignaturePropo(
                            this.contextDossier.emprunteur.assurance.statutDA
                        )
                    ) {
                        this.router.navigateByUrl(
                            '/souscription/document-medicale/chargement'
                        );
                    } else {
                        this.isLoading = true;
                        this.routerHelper.routeAfterSignature(
                            this.idPersonne,
                            this.idDossier
                        );
                    }
                    break;
            }
        }
    }

    ngOnInit(): void {
        this.isLoading = true;
        this.resizeIframe();
        this.espaceClientService
            .refreshEspaceClient(this.idPersonne)
            .subscribe((data) => {
                this.initFromEspaceClient(data);
            });
        window.scrollTo(0, 0);
    }

    navigateToEspaceClient() {
        this.router.navigateByUrl(RouteEnum.dashboard);
    }

    urlSignature() {
        this.signatureUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
            this.signatureService.getSignature(this.idDossier, this.idPersonne)
        );
    }

    initFromEspaceClient(espaceClient: any): void {
        this.contextDossier = ContextDossier.initContextDossierFromEspaceClient(
            this.idPersonne,
            this.idDossier.toString(),
            espaceClient
        );
        if (
            AssuranceHelperService.isCodeAiaStatutDAForSignaturePropo(
                this.contextDossier.emprunteur.assurance.statutDA
            )
        ) {
            this.currentStepId = 'signature_propo';
            this.espaceDocumentaireService
                .getEspaceDocumentaire(
                    this.idPersonne,
                    this.contextDossier.emprunteur.assurance
                        .idPropositionPrincipale
                )
                .subscribe((documents) => {
                    this.isPropositionSigned =
                        this.isPropositionSignedExist(documents);
                    this.isLoading = false;
                });
        } else {
            this.currentStepId = 'signature_dad';
            this.isLoading = false;
        }
    }

    /**
     * Retourne true si il existe une proposition d assurance signee dans l espace documentaire
     *
     * @param documents: liste des documents de l espace documentaire
     */
    isPropositionSignedExist(documents: DocumentGed[]): boolean {
        let isPropositionSignedExist = false;
        if (documents) {
            const docPropo = documents.find((doc) =>
                doc.typologie
                    .toUpperCase()
                    .startsWith(SignatureComponent.prefixTypologieProposition)
            );
            isPropositionSignedExist =
                docPropo !== null && docPropo !== undefined;
        }

        return isPropositionSignedExist;
    }

    calculateQuote(isMobile: boolean, width: number): number {
        if (isMobile && width < 498) {
            return 200000;
        } else if (isMobile && width > 499 && width < 769) {
            return 140000;
        } else if (width > 768 && width < 1091) {
            return 100000;
        } else {
            return 90000;
        }
    }

    resizeIframe(): void {
        const width = this.getWindowWidth();
        const isMobile = this.deviceDetectorService.isMobile();
        const quote = this.calculateQuote(isMobile, width);

        const calculatedHeight = 1100 + quote / width;
        this.iframeHeight = `${calculatedHeight}px`;
    }
    getWindowWidth(): number {
        return (
            window.innerWidth ||
            document.documentElement.clientWidth ||
            document.body.clientWidth
        );
    }
}
